module.exports = global["_"] = require("-!./underscore.js");


/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore/underscore.js-exposed
 ** module id = 2
 ** module chunks = 19
 **/